<template>
  <v-tooltip
    v-if="isAdmin"
    right
  >
    <template #activator="{ props }">
      <v-btn
        v-clipboard:copy="copyTokenString"
        v-clipboard:success="handleSuccess"
        v-clipboard:error="handleError"
        class="ma-2"
        color="primary"
        v-bind="props"
      >
        Copy API Token
      </v-btn>
    </template>
    An API token is required to access the Qumulex Portal API
  </v-tooltip>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "HelpDialogTooltip",
  props: {
    isAdmin: Boolean,
    isLoggedIn: Boolean,
    tokenString: String,
  },
  computed: {
    copyTokenString() {
      return this.isLoggedIn ? this.tokenString : "No logged in user";
    },
  },

  methods: {
    handleSuccess(e) {
      console.log("Clipboard Success: ");
      console.log(e);
    },
    handleError(e) {
      console.error("Clipboard Error: ");
      console.log(e);
    },
  },
});
</script>
